import { Motorista } from "../../models/Motorista.ts";
import { api } from "./UrlPadrao.js";

interface DisponibilidadeFrotaParams {
	token: string;
	dias: number;
	eixos: number;
	status: number;
	data: string;
	tipoCarroceriaId: number;
	elegivelBrf: number;
}

export const getDisponibilidadeFrota = async (
	{ token, dias, eixos, status, data, tipoCarroceriaId, elegivelBrf }: DisponibilidadeFrotaParams
): Promise<Motorista[]> => {
	const response = await api.get(`veiculo/disponibilidade-frota/${dias}/${eixos}/${status}/${data}/${tipoCarroceriaId}/${elegivelBrf}`,
		{
			headers: {
				'Authorization': token
			}
		});
	return response.data;
}
